module.exports = __webpack_public_path__ + "static/media/icon_tool_atendimento.3a34d2e5.svg";